import { render, staticRenderFns } from "./arvioinnit-list.vue?vue&type=template&id=63679747&scoped=true&"
import script from "./arvioinnit-list.vue?vue&type=script&lang=ts&"
export * from "./arvioinnit-list.vue?vue&type=script&lang=ts&"
import style0 from "./arvioinnit-list.vue?vue&type=style&index=0&id=63679747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63679747",
  null
  
)

export default component.exports